import {BUSCAR_MOTORISTAS} from '../../actions/types'

const initialState = undefined;

export default function reducerMotoristas(state = [], action = initialState) {
    switch (action.type) {
        case BUSCAR_MOTORISTAS: {
            const usuarios = action.payload.data;

            if (usuarios) {
                return usuarios
            }
            return []
        }

        default: {
            return state
        }
    }
}
